import { useTheme } from "@mui/material";
import { TypeTypography } from "./CalendarCarouselCard.style";
import {
  useLevel
} from "../../hooks";
import type { Level } from "../../types";

export function LevelLabel({ learningObjectTypology }: { learningObjectTypology?: Level}) {
  const theme = useTheme();
  const learningObjectTypologyLabel = useLevel(learningObjectTypology);
  return ( 
    <TypeTypography 
      variant={ "h5" } 
      sx={ { color: theme.customColors.exploreCardText } }
    >
      { learningObjectTypologyLabel }
    </TypeTypography>
  );}

